var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9666 61.6333V27.7666C27.9666 26.4333 28.3666 25.1333 29.0999 24.0333L38.1999 10.5C39.6332 8.33329 43.1999 6.79996 46.2332 7.93329C49.4999 9.03329 51.6666 12.7 50.9666 15.9666L49.2332 26.8666C49.0999 27.8666 49.3666 28.7666 49.9332 29.4666C50.4999 30.1 51.3332 30.5 52.2332 30.5H65.9332C68.5666 30.5 70.8332 31.5666 72.1666 33.4333C73.4332 35.2333 73.6666 37.5666 72.8332 39.9333L64.6332 64.9C63.5999 69.0333 59.0999 72.3999 54.6332 72.3999H41.6332C39.3999 72.3999 36.2666 71.6333 34.8332 70.2L30.5666 66.9C28.9332 65.6666 27.9666 63.7 27.9666 61.6333Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3667 21.2667H13.9334C8.76675 21.2667 6.66675 23.2667 6.66675 28.2001V61.7334C6.66675 66.6667 8.76675 68.6667 13.9334 68.6667H17.3667C22.5334 68.6667 24.6334 66.6667 24.6334 61.7334V28.2001C24.6334 23.2667 22.5334 21.2667 17.3667 21.2667Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.ea84102bcb2140fde20bf11fd2f88658.svg";
export { ForwardRef as ReactComponent };